import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'tanok';
import { t } from 'c-3po';

import { toJS } from '../../../helpers/ImmutableToJS';

import { Config } from './../../../../core/config';
import * as a from './../../../../libs/actions';
import * as c from './../../../../libs/constants';

import { Button } from '../../../ui/button';
import { Input } from '../../../ui/input';

import { Social } from '../../../components/social';

// styles
import css from './authBody.sss';


class LoginView extends React.Component {

    static propTypes = {
        loginFields: PropTypes.object,
        fieldsErrors: PropTypes.object,
        isLoadingData: PropTypes.object,
        sendAnaliticsAction: PropTypes.func,
    };

    componentDidMount() {
        this.props.send(a.EVENT_REGISTER_AUTH_TRACKER,
            { node: document.getElementById(this.formId) });
    }

    handlePhoneEmailChange = ({ target }) => {
        const { value } = target;
        this.props.send(a.EVENT_AUTH_PHONE_EMAIL_CHANGE, { value });
    }

    handlePasswordChange = ({ target }) => {
        const { value } = target;
        this.props.send(a.EVENT_AUTH_PASSWORD_CHANGE, { value });
    }


    handleSubmitLogin = (ev) => {
        ev.preventDefault();
        const isSmartWebMail = this.props.loginFields.phoneEmail.indexOf('@smartweb') !== -1;
        const muchNotify = alert;
        const msgText = t`Для авторизации через почту smartweb, используйте стандартную форму аутентификации.`;

        if (isSmartWebMail) muchNotify(msgText);
        else this.props.send(a.TR_AUTHENTICATE_USER);
    }

    formId = 'chat-auth-form-port';

    render() {
        const { DEFAULT_ORIGIN: BASE_URL } = Config.data.appState;

        const { loginFields, fieldsErrors, isLoadingData, sendAnaliticsAction } = this.props;

        return (
            <div className={css.root}>
                <div className={css.container}>
                    <div className={css.content}>
                        <Social sendAnaliticsAction={sendAnaliticsAction} />
                        <div className={css.spacer}>
                            <span className={css.spacerText}>Или через эл. почту</span>
                        </div>
                        <form
                            onSubmit={this.handleSubmitLogin}
                            data-qaid='auth_form'
                            id={this.formId}
                        >
                            <div className={css.row}>
                                <Input
                                    name='phone_email'
                                    dataQa='phone_email_input'
                                    placeholder={t`Введите email или телефон`}
                                    value={loginFields.phoneEmail}
                                    autoFocus
                                    maxLength='100'
                                    error={fieldsErrors.phone_email}
                                    onChange={(event) => this.handlePhoneEmailChange(event)}
                                />
                                {fieldsErrors.phone_email && (fieldsErrors.phone_email.map((error) => (
                                    <div
                                        className={css.fieldError}
                                        dangerouslySetInnerHTML={{ __html: error }}
                                    />
                                )))}
                            </div>
                            <div className={css.row}>
                                <Input
                                    type='password'
                                    name='password'
                                    dataQa='pwd_input'
                                    placeholder={t`Пароль`}
                                    value={loginFields.password}
                                    maxLength='100'
                                    error={fieldsErrors.password}
                                    onChange={(event) => this.handlePasswordChange(event)}
                                />
                                {fieldsErrors.password && (fieldsErrors.password.map((error) => (
                                    <div
                                        className={css.fieldError}
                                        dangerouslySetInnerHTML={{ __html: error }}
                                    />
                                )))}
                            </div>
                            <div className={css.row}>
                                <Button
                                    type='submit'
                                    isLoading={isLoadingData.login}
                                    dataQa='sign_in_btn'
                                    disabled={!loginFields.phoneEmail || !loginFields.password}
                                >
                                    {t`Войти`}
                                </Button>
                            </div>
                            <div className={css.additionalControls}>
                                <a
                                    className={css.link}
                                    href={`${BASE_URL}/remote/account/forgot_password?_region=None`}
                                    onClick={sendAnaliticsAction(c.ANALCS_ACTION_PASS_REMIND)}
                                >
                                    {t`Забыли пароль?`}
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loginFields: state.get('loginFields'),
    fieldsErrors: state.get('fieldsErrors'),
    isLoadingData: state.get('isLoadingData'),
    locale: state.get('locale')
});


export const Login = connect(mapStateToProps)(toJS(LoginView));
